import { createFileRoute, stripSearchParams } from '@tanstack/react-router'

import { DEFAULT_DOCUMENTS_SEARCH, DocumentsScreen, documentsSearchSchema, toListFilters } from '@/features/documents'
import { documentsListQuery } from '@/lib/api/queries/documents'
import { languagesQuery } from '@/lib/api/queries/meta'

export const Route = createFileRoute('/_auth/documents/')({
  validateSearch: documentsSearchSchema,
  // Defaults stay out of the URL, so /documents is the plain, shareable form.
  search: { middlewares: [stripSearchParams(DEFAULT_DOCUMENTS_SEARCH)] },
  loaderDeps: ({ search }) => ({ filters: toListFilters(search) }),
  // Not awaited: the screen keeps the previous rows while a new filter loads, so the URL and the
  // tabs respond at once.
  loader: ({ context, deps }) => {
    void context.queryClient.prefetchInfiniteQuery(documentsListQuery(deps.filters))
    void context.queryClient.prefetchQuery(languagesQuery)
  },
  component: DocumentsRoute,
})

function DocumentsRoute() {
  const search = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <DocumentsScreen
      search={search}
      onSearchChange={(patch, options) =>
        void navigate({ search: (prev) => ({ ...prev, ...patch }), replace: options?.replace ?? true })
      }
      onCreated={(docId) => void navigate({ to: '/documents/$docId/preparing', params: { docId } })}
    />
  )
}
